/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ category: NonNullable<unknown> }} Help_More_InInputs */

const en_help_more_in = /** @type {(inputs: Help_More_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More in ${i?.category}`)
};

const pl_help_more_in = /** @type {(inputs: Help_More_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Więcej w: ${i?.category}`)
};

/**
* | output |
* | --- |
* | "More in {category}" |
*
* @param {Help_More_InInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_more_in = /** @type {((inputs: Help_More_InInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_More_InInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_more_in(inputs)
	return en_help_more_in(inputs)
});